export default __webpack_public_path__ + "static/media/Interior (5).7135bd55.jpg";